<!-- Initialization Loading State -->
<div class="init-loading-state" *ngIf="isInitializing">
  <div class="init-loading-content">
    <div class="init-loading-spinner"></div>
    <span>Loading Messages...</span>
  </div>
</div>

<div class="messages-container" *ngIf="!isInitializing">
  <!-- No Organizations State -->
  <div class="no-org-state" *ngIf="organizations.length === 0">
    <div class="no-org-content">
      <i class="fa-solid fa-building-circle-xmark fa-3x"></i>
      <h2>No Organizations</h2>
      <p>You are not a member of any organization. Contact your administrator to get access.</p>
    </div>
  </div>

  <!-- Message Approval Panel (full width, full height) -->
  <div class="content-body" *ngIf="organizations.length > 0">
    <izzy-message-approval
      [organizationId]="selectedOrg?.ID"
      [channelId]="selectedChannel?.ID">
    </izzy-message-approval>
  </div>
</div>
